module.exports = __webpack_public_path__ + "assets/img/service-process.ff7c3f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/service-process.png
// module id = dAj7
// module chunks = 1